/**
 * Full-story / analytics element labels (rendered as `data-track-label` in the DOM).
 * Keep in sync with the AI Search tracking label definitions.
 */
export const AI_SEARCH_TRACK_LABELS = {
  SEND_MESSAGE_CTA: 'AI Search Send Message CTA',
  SUGGESTED_SEARCH_CHIPS: 'AI Search Suggested Search Chips',
  THUMBS_UP: 'AI Search Thumbs Up',
  THUMBS_DOWN: 'AI Search Thumbs Down',
  VIEW_ALL_PROPERTIES: 'AI Search View All Properties',
  STOP_CONVERSATION: 'AI Search Stop Conversation',
  MESSAGE_LOADING: 'AI Search Message Loading',
  TRY_AGAIN_ERROR_MESSAGE: 'AI Search Try Again Error Message',
  TRY_AGAIN_CTA: 'AI Search Try Again CTA',
  NEW_CHAT: 'AI Search New Chat',
  CHAT_HISTORY: 'AI Search Chat History',
  CHAT_COMPONENT_FAVORITES: 'AI Search Chat Favorites',
  DATE_INPUT: 'AI Search Date Input Field',
  ROOMS_PARTY_INPUT: 'AI Search Rooms / Party Mix Input Field',
  RATE_INPUT: 'AI Search Rate Input Field',
  APPLY: 'AI Search Apply',
  MAP_PROPERTY_CARD: 'AI Search Map Property Card',
  LIST_VIEW: 'AI Search List View',
  MAP_VIEW: 'AI Search Map View',
  LIST_VIEW_PROPERTY_CARD_CTA: 'AI Search List View Property Card CTA',
  SEARCH_ALL_PROPERTIES_CTA: 'AI Search Search All Properties CTA',
  HQV_VIEW_RATES_CTA: 'AI Search HQV View Rates CTA',
} as const;

export type AiSearchTrackLabel = (typeof AI_SEARCH_TRACK_LABELS)[keyof typeof AI_SEARCH_TRACK_LABELS];
